import template from './periodos-nominas.html';
import { FormActions } from 'core/services/form';
import periodosNominasI18N from 'i18n/periodos-nominas/es.json';
import { rest } from 'core/api';
import { fechaRenderer } from 'core/util';
import { formatErrorMessage } from 'core/util';

export let PeriodosNominasComponent = {
  templateUrl: template,
  selector: 'periodosNominas',
  bindings: {
    translations: '='
  },
  controller: PeriodosNominasCtrl,
  controllerAs: 'vm'
};

const commonsI18N = [
  'Elemento borrado correctamente'
];
export const translationKeys = Object.keys(periodosNominasI18N).concat(commonsI18N);

PeriodosNominasCtrl.$inject = [
  'BasicFactory', '$ngRedux', '$state', 'ngNotify', 'Filter', 'AuthorizationService', 'ConfirmationModal'
];

function PeriodosNominasCtrl(BasicFactory, $ngRedux, $state, ngNotify, Filter,
  AuthorizationService, ConfirmationModal) {

  Object.assign(this, { $state, $ngRedux, ngNotify });
  var defaultColumnOrder = ['nombre', 'estado.value', 'desde', 'hasta'];
  var staticFilter = Filter.path('activo').eq(true);
  const estadosQuery = Filter.path('tipo.codigo').eq('estado_periodo_nomina');
  const estadosUrl = encodeURI('valores?filter=' + JSON.stringify(estadosQuery));
  BasicFactory.setup('periodos-nominas');

  this.options = {
    staticFilter,
    resource: 'periodos-nominas',
    hideHeader: true,
    hasOptions: true,
    title: this.translations['Listado de periodos de nómina'],
    factory: BasicFactory,
    defaultColumnOrder: defaultColumnOrder,
    columns: [
      { data: 'id', title: 'Id' },
      { data: 'nombre', title: this.translations['Nombre'] },
      {
        data: 'estado.value',
        title: this.translations['Estado'],
        type: 'combo',
        filterUrl: estadosUrl,
        idField: 'value',
        textField: 'value',
        keyData: 'data'
      },
      { data: 'desde', title: this.translations['Desde'], renderWith: fechaRenderer, type: 'date-range' },
      { data: 'hasta', title: this.translations['Hasta'], renderWith: fechaRenderer, type: 'date-range' }
    ],
    defaultOrderColumn: 0,
    defaultOrderDir: 'desc',
    onEdit: onEdit.bind(this),
    onRemove: onRemove.bind(this),
    onView: onView.bind(this),
    canEditCondition: canEdit.bind(this),
    canRemoveCondition: canRemove.bind(this),
    canOpenPeriodo: (periodo) => {
      const authorized = AuthorizationService.hasPermission('abrir_periodos_nominas');

      if (!authorized) {
        return authorized;
      }
      return periodo.estado.value === 'Nunca abierto';
    },
    canClosePeriodo: (periodo) => {
      const authorized = AuthorizationService.hasPermission('cerrar_periodos_nominas');

      if (!authorized) {
        return authorized;
      }
      return periodo.estado.value === 'Abierto' ||
        periodo.estado.value === 'Reabierto';
    },
    canReOpenPeriodo: (periodo) => {
      const authorized = AuthorizationService.hasPermission('reabrir_periodos_nominas');

      if (!authorized) {
        return authorized;
      }
      return periodo.estado.value == 'Cerrado';
    },
    extraRowOptions: [
      {
        templateToRender: '<button class="btn-row-datatable btn btn-primary btn-dt" uib-tooltip="' + this.translations['Abrir periodo'] + '" ng-show="options.canOpenPeriodo(rowsData[<%= dataId %>])" ng-click="abrirPeriodo(<%= dataId %>)"> <span class="glyph-icon icon-unlock" style="top: -8px;"></span></button>',
        functionName: 'abrirPeriodo',
        functionDef: (itemId) => {
          ConfirmationModal.open({
            title: 'Abrir periodo',
            id: itemId,
            message: '¿Desea abrir el periodo?',
            ok: function() {
              $ngRedux.dispatch(rest.actions.abrirPeriodoNomina({ id: itemId }));
            }
          });
        }
      }, {
        templateToRender: '<button class="btn-row-datatable btn btn-primary btn-dt" uib-tooltip="' + this.translations['Cerrar periodo'] + '" ng-show="options.canClosePeriodo(rowsData[<%= dataId %>])" ng-click="cerrarPeriodo(<%= dataId %>)"> <span class="glyph-icon icon-lock" style="top: -8px;"></span></button>',
        functionName: 'cerrarPeriodo',
        functionDef: (itemId) => {
          ConfirmationModal.open({
            title: 'Cerrar periodo',
            id: itemId,
            message: '¿Desea cerrar el periodo?',
            ok: function() {
              $ngRedux.dispatch(rest.actions.cerrarPeriodoNomina({ id: itemId }));
            }
          });
        }
      }, {
        templateToRender: '<button class="btn-row-datatable btn btn-primary btn-dt" uib-tooltip="' + this.translations['Reabrir periodo'] + '" ng-show="options.canReOpenPeriodo(rowsData[<%= dataId %>])" ng-click="reabrirPeriodo(<%= dataId %>)"> <span class="glyph-icon icon-unlock" style="top: -8px;"></span></button>',
        functionName: 'reabrirPeriodo',
        functionDef: (itemId) => {
          ConfirmationModal.open({
            title: 'Reabrir periodo',
            id: itemId,
            message: '¿Desea reabrir el periodo?',
            ok: function() {
              $ngRedux.dispatch(rest.actions.abrirPeriodoNomina({ id: itemId }));
            }
          });
        }
      }
    ]
  };

  function canEdit(data) {
    return data.estado.value !== 'Cerrado' && AuthorizationService.hasPermission('update_periodos_nominas');
  }

  function canRemove(data) {
    return data.estado.value !== 'Cerrado' && AuthorizationService.hasPermission('delete_periodos_nominas');
  }

  this.handleStatus = handleStatus.bind(this);
  this.mapStateToThis = mapStateToThis.bind(this);
  this.gotoForm = gotoForm.bind(this);
  const unsubscribe = $ngRedux.connect(this.mapStateToThis, FormActions)(this);

  this.$onDestroy = () => {
    this.form();
    unsubscribe();
  };

  this.$onInit = () => {
    this.reportOptions = {
      title: this.translations['Listado de periodos de nómina']
    };
    this.form();
  };

  function mapStateToThis(state) {
    this.handleStatus(state);
    return { form: state.form };
  }

  function handleStatus(state) {
    if (state.form.removed) {
      this.ngNotify.set(this.translations['Elemento borrado correctamente'], 'success');
      this.options.reloadData();
      this.form();
    }

    if (state.form.error) {
      ngNotify.set(formatErrorMessage(state.form.error.message), { type: 'error', html: true });
    }

    if (state.abrirPeriodoNomina.data) {
      let { estado } = state.abrirPeriodoNomina.data;

      if (estado && estado.value === 'Abierto' ||
        estado && estado.value === 'Reabierto') {
        this.ngNotify.set(this.translations['Periodo abierto correctamente'], 'success');
        this.$ngRedux.dispatch(rest.actions.abrirPeriodoNomina.reset());
        this.options.reloadData();
      }
    }

    if (state.abrirPeriodoNomina.error) {
      this.ngNotify.set(this.translations['Error al intentar abrir el periodo'], 'error');
      this.$ngRedux.dispatch(rest.actions.abrirPeriodoNomina.reset());
    }

    if (state.cerrarPeriodoNomina.data) {
      let { estado } = state.cerrarPeriodoNomina.data;

      if (estado && estado.value === 'Cerrado') {
        this.ngNotify.set(this.translations['Periodo cerrado correctamente'], 'success');
        this.$ngRedux.dispatch(rest.actions.cerrarPeriodoNomina.reset());
        this.options.reloadData();
      }
    }

    if (state.cerrarPeriodoNomina.error) {
      this.ngNotify.set(this.translations['Error al intentar cerrar el periodo'], 'error');
      this.$ngRedux.dispatch(rest.actions.cerrarPeriodoNomina.reset());
    }
  }

  function gotoForm() {
    this.$state.go('home.periodos-nominas.new');
  }

  function onEdit(itemId) {
    this.$state.go('home.periodos-nominas.uid.edit', { uid: itemId });
  }

  function onRemove(itemId) {
    this.remove('periodos-nominas', itemId);
  }

  function onView(itemId) {
    this.$state.go('home.periodos-nominas.uid.view', { uid: itemId });
  }
}


// WEBPACK FOOTER //
// ./src/components/periodos-nominas/list/periodos-nominas.component.js